import type { ReplayRecord, ReplayStorePort, ReplaySummary } from '../ports/replays';
import { toReplaySummary } from '../ports/replays';
import { lazyClientDb, REPLAY_SUMMARIES_STORE, REPLAYS_STORE } from './indexed-db';

export class IndexedDBReplayStore implements ReplayStorePort {
  private readonly getDb = lazyClientDb();

  async saveReplay(replay: ReplayRecord): Promise<void> {
    const db = await this.getDb();
    const tx = db.transaction([REPLAYS_STORE, REPLAY_SUMMARIES_STORE], 'readwrite');
    await Promise.all([
      tx.objectStore(REPLAYS_STORE).put(replay),
      tx.objectStore(REPLAY_SUMMARIES_STORE).put(toReplaySummary(replay)),
      tx.done,
    ]);
  }

  async getReplay(id: string): Promise<ReplayRecord | null> {
    return ((await (await this.getDb()).get(REPLAYS_STORE, id)) as ReplayRecord | undefined) ?? null;
  }

  async listReplays(): Promise<ReplaySummary[]> {
    const rows = (await (await this.getDb()).getAll(REPLAY_SUMMARIES_STORE)) as ReplaySummary[];
    return rows.sort((a, b) => b.completedAt - a.completedAt);
  }

  async deleteReplay(id: string): Promise<void> {
    const db = await this.getDb();
    const tx = db.transaction([REPLAYS_STORE, REPLAY_SUMMARIES_STORE], 'readwrite');
    await Promise.all([
      tx.objectStore(REPLAYS_STORE).delete(id),
      tx.objectStore(REPLAY_SUMMARIES_STORE).delete(id),
      tx.done,
    ]);
  }

  async clearReplays(): Promise<void> {
    const db = await this.getDb();
    const tx = db.transaction([REPLAYS_STORE, REPLAY_SUMMARIES_STORE], 'readwrite');
    await Promise.all([tx.objectStore(REPLAYS_STORE).clear(), tx.objectStore(REPLAY_SUMMARIES_STORE).clear(), tx.done]);
  }
}
